import JobInfoBanner from './JobInfoBanner'

export default JobInfoBanner
